import React, { FunctionComponent } from "react";
import { TextField } from "@material-ui/core";
import IRecipientDetailsProps from "./Recipient";
import { DropdownIcon, UserPhotoUpload } from "../../../../assets/Icons";

export const StepOne: FunctionComponent<IRecipientDetailsProps.StepOneProps> = ({
  name,
  setName,
  relationship,
  setIsModalOpen,
}) => {
  return (
    <div className="flex justify-center space-x-16">
      <UserPhotoUpload />
      <div className="space-y-7">
        <TextField
          className="w-[400px]"
          variant="outlined"
          name="username"
          label="Name"
          required={true}
          onChange={(e) => setName(e.target.value)}
          value={name}
          inputProps={{ pattern: "[a-zA-Z0-9 ]{1,}" }}
        />
        <div
          id="relationship"
          onClick={() => setIsModalOpen("relationship")}
          className="h-[58px] border flex bg-white items-center border-gray-400 rounded p-4 text-[14px] justify-between cursor-pointer"
        >
          <div>{relationship ? `${relationship}` : "Relationship*"}</div>
          <div>
            <DropdownIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
